import {FilterTextComponentInterface} from '../../partial-components/filters/filter-text/filter-text.component';

export const UserManagementFilterTextConfig: FilterTextComponentInterface = {
    inputPlaceholder: 'userManagement.filters.filterTextPlaceholder'
};
